import { Box, Button, Typography } from '@mui/material'
import cookies from 'js-cookie'
import React from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'

import { Container, Content } from './common'
import { InvitationResponse } from './types'

type Props = {
  invitationResponse: InvitationResponse
  url: string
}

const LoggedOutExisting: React.FC<Props> = ({ invitationResponse, url }) => {
  const navigate = useNavigate()

  React.useEffect(() => {
    cookies.set('redirectURL', url, { sameSite: 'strict', secure: true })
  }, [url])

  return (
    <Container>
      <Content>
        <Typography className="invitation-message-text" variant="h5" textAlign="center">
          You have been invited to the organization {invitationResponse.orgName} ({invitationResponse.orgId}).
          <br /> If you want to join that organization, you have to login first.
        </Typography>
        <Box pt={2} textAlign="center">
          <Button variant="contained" color="primary" onClick={() => navigate('/login')}>
            Login
          </Button>
        </Box>
      </Content>
    </Container>
  )
}

export default LoggedOutExisting
